module.exports = __webpack_public_path__ + "images/psp/CarStorage/Winterizing-Your-RV.png";